import type { ShortUrl } from '@creator/sdk/modules/short-url/short-url.model';
import creatorSdk from '@src/services/creator-sdk';

export async function createShortUrl(originalUrl: string): Promise<ShortUrl> {
    return creatorSdk.shortUrlModule.createShortUrl(originalUrl);
}
